import { federalBankHolyDays } from "../pages/DrawRequests/data/holydays";
import { holidays, holidaysNextYear } from "./getDueDateForCheck";
import { Moment } from "moment";


const allHolidaysSet = new Set<string>([
    ...holidays,
    ...holidaysNextYear,
]);

export const disabledHolyAndWeekendDate = (current: Moment | null): boolean => {
    if (!current) return false;

    const isWeekend = current.day() === 0 || current.day() === 6;

    const formatted = current.format("MM/DD/YYYY");

    const isHoliday = allHolidaysSet.has(formatted);

    return isWeekend || isHoliday;
};